/**
 * Created by Arison on 19:45.
 * 充值详情界面
 */
import React from 'react';
import {Divider} from "antd";
import "./RechargeDetai.css"
import {fetchGet} from "../../utils/fetchRequest";
import {API} from "../../configs/api.config";
import  {Toast } from "antd-mobile";

class RechargeDetail extends React.Component{
    constructor(props){
        super(props);
        this.state={
            name:'RechargeDetail',
            data:{

            }
        };
    }


    componentDidMount(){
        Toast.loading("");
       fetchGet(API.GET_PAY_DETAIL,{
                   id:this.props.match.params.payId
                 }).then((response)=>{
                 Toast.hide()
                     console.log("response:"+JSON.stringify(response));
                     if(response.success){
                         this.setState({data:response.data});
                     }
                 }).catch((error)=>{
           Toast.hide()
                     console.log("error:"+JSON.stringify(error));
                 })
    }

    render(){

        return <div className="padding_15">
                <div className="flex_row margin_top_20">
                    <span className="item_flex_3 span_22 text_bold_500">充值金额</span>
                    <span className="item_flex  item_end span_22 text_bold_500">{this.state.data.payAmount}元</span>
                </div>
               <Divider />
                <div className="flex_row">
                    <span className="item_flex_3 span_15">充值状态</span>
                    <span className="item_flex  item_end color_lightGreen span_16">
                        {this.state.data.assignStatus==null?(""):this.state.data.assignStatus=="NOT_ASSIGNED"?(<div className="color_red">待圈卡</div>):("充值成功")}
                        </span>
                </div>

            <div className="flex_row margin_top_10">
                <span className="item_flex_3 span_15">消费卡号</span>
                <span className="item_flex  item_end span_16">{this.state.data.cardNo}</span>
            </div>

            <div className="flex_row margin_top_10">
                <span className="item_flex_3 span_15">支付方式</span>
                <span className="item_flex  item_end span_16">{this.state.data.chargeMethod}</span>
            </div>

            <div className="flex_row margin_top_10">
                <span className="item_flex_3 span_15">支付时间</span>
                <span className="item_flex  item_end span_16">{this.state.data.payDate}</span>
            </div>

            <div className="flex_row margin_top_10">
                <span className="item_flex_3 span_15">支付单号</span>
                <span className="item_flex  item_end span_16 ">{this.state.data.payOrderCode}</span>
            </div>

            <div className="flex_row margin_top_10">
                <span className="item_flex_3 span_15">圈存单号</span>
                <span className="item_flex  item_end span_16">{this.state.data.assignOrderCode}</span>
            </div>
            <Divider />
        </div>
    }
}

export  default RechargeDetail;